// extracted by css-extract-rspack-plugin
export default {"openLabel":"xYNe9RrTMcE1jwpp","staticLabel":"Bf6oXfRVo8fqjbCc","inputWrapper":"uxLuxKZiysLLLKJt"};